import sidebarContent from './sidebarContent'

// Array of sections
export default [...sidebarContent]
